import { cn } from '@/helpers/utils'

const colorVariants = {
  primary: 'bg-game-primary text-black',
  dark: 'bg-background-dark text-white',
  accent: 'bg-game-accent text-black',
  purple: 'bg-game-purple text-white',
  warning: 'bg-amber-500 text-black',
  error: 'bg-red-500 text-white',
}

export function NewsTicker({ 
  items = [], 
  color = 'primary',
  speed = 30, // seconds for one complete cycle
  separator = ' • ',
  className 
}) {
  // Join items with separator
  const tickerText = items.join(separator)
  
  return (
    <div 
      className={cn(
        'w-full py-2 overflow-hidden whitespace-nowrap',
        colorVariants[color],
        className
      )}
    >
      <div className="flex">
        {/* First copy */}
        <div 
          className="inline-block text-[10px] font-black uppercase tracking-[0.2em] animate-ticker shrink-0"
          style={{ animationDuration: `${speed}s` }}
        >
          {tickerText}{separator}
        </div>
        {/* Second copy for seamless loop */}
        <div 
          className="inline-block text-[10px] font-black uppercase tracking-[0.2em] animate-ticker shrink-0"
          style={{ animationDuration: `${speed}s` }}
        >
          {tickerText}{separator}
        </div>
      </div>
    </div>
  )
}
